import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { SubHeaderData } from '../../../../../models/sub-header-data';
import { SettingValueModel } from '../../../models/informate';
import { MatTabGroup } from '@angular/material/tabs';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-settings-general',
    templateUrl: './settings-general.component.html',
    styleUrls: ['./settings-general.component.scss'],
    standalone: false
})
export class SettingsGeneralComponent implements OnInit, AfterViewInit {
    @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

    subHeaderData: SubHeaderData;
    generalTabIndex: any;
    language: SettingValueModel;
    hideTabHeroImages: boolean;
    hideTabNews: boolean;
    hideTabPricingDetails: boolean;

    constructor(private user_utility: UserUtilityService,
             private translocoService: TranslocoService) {}

    async ngOnInit(): Promise<void> {
        this.subHeaderData = this.setSubHeaderValues();
        //TODO load existing Data
        this.hideTabHeroImages = await this.user_utility.checkUserPermissionDataAndRoute('heroImages', userActions.View);
        this.hideTabNews = await this.user_utility.checkUserPermissionDataAndRoute('news', userActions.View);
        this.hideTabPricingDetails = await this.user_utility.checkUserPermissionDataAndRoute('Pricing', userActions.View);
    }

    ngAfterViewInit(): void {
        this.generalTabIndex = this.tabGroup._tabs.first?.ariaLabel;
    }

    setSubHeaderValues(): SubHeaderData {
        let headerData = new SubHeaderData();
        headerData.displayText =  this.translocoService.translate('SETTING_PAGE.SETTING_SUB_HEADER.Settings');
        headerData.disableActions = true;
        headerData.defaultImageSrc = '../../../../../../assets/media/logos/settings-black.png';
        headerData.mouseOverImageSrc = '../../../../../../assets/media/logos/settings-yellow.png';
        headerData.isGeneralSettings = true;
        headerData.generalTabIndex = this.generalTabIndex;
        return headerData;
    }

    languageOutputHandler(settingValueModel: SettingValueModel) {
        this.language = settingValueModel;
    }

    tabChanged(event: any): void {
        this.generalTabIndex = this.tabGroup._tabs.find((tab) => tab.textLabel === event.tab.textLabel).ariaLabel;
    }
}
